import React, { FC } from 'react';
import { useIsMobile } from '@sravni/react-utils';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FORM_FIELDS, FORM_STEPS, LABELS, PAGE } from '../../../../../constants';
import { useFormStore } from '../../../../../store/selectors/formStore';
import { PhoneInput } from '../../../../landing.common';

export const PhoneForm: FC<{ form: UseFormReturn; page: ValuesOf<typeof PAGE> }> = ({ form, page }) => {
    const { oncePassedSteps = [], userId } = useFormStore();
    const isMobile = useIsMobile();

    const {
        control,
        formState: { errors, dirtyFields: _ },
    } = form;

    const isPhoneDisabled =
        Boolean(userId) ||
        [PAGE.CALLCENTER, PAGE.CALLCENTER_MAIN_FORM_EDIT].includes(page) ||
        (page == PAGE.AGENTS && oncePassedSteps.includes(FORM_STEPS.PARAMS));

    const isPhoneMasked = [PAGE.CALLCENTER, PAGE.CALLCENTER_MAIN_FORM_EDIT].includes(page);
    const fieldType = isPhoneMasked ? 'password' : isMobile ? 'tel' : 'text';

    return (
        <Controller
            control={control}
            name={FORM_FIELDS.PHONE}
            render={({ field }) => (
                <PhoneInput
                    {...field}
                    disabled={isPhoneDisabled}
                    type={fieldType}
                    label={LABELS[FORM_FIELDS.PHONE]}
                    errorMessage={errors[FORM_FIELDS.PHONE]?.message as string}
                />
            )}
        />
    );
};
